import axios from "axios";

export const fetchUpdateTaskSubmit = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.put(`${baseTaskUrl}/TaskSubmission/${data.id}`, data);
};
